<template>
  <div class="preika-auth-page">
    <div class="preika-auth-shell">
      <section class="preika-auth-brand">
        <img
          src="/img/avatars/preika_black.png"
          alt="PREIKA"
          class="preika-auth-brand__logo"
        >

        <div class="preika-auth-brand__content">
          <p class="preika-auth-brand__eyebrow">ACCOUNT RECOVERY</p>
          <h1>安全にアカウントを<br>再設定します。</h1>
          <p>
            ご本人確認用のURLを登録済みメールアドレスへ送信します。
            メールに記載された手順に沿って、新しいパスワードを設定してください。
          </p>
        </div>
      </section>

      <section class="preika-auth-form">
        <p class="preika-auth-form__eyebrow">RESET PASSWORD</p>
        <h2>パスワード再設定</h2>
        <p class="preika-auth-form__description">
          PREIKAに登録されているメールアドレスを入力してください。
        </p>

        <ValidationObserver ref="obs" v-slot="observerProps">
          <CForm @submit.prevent="sendMail">
            <div
              v-if="errors.length"
              class="alert alert-danger"
              role="alert"
            >
              <div
                v-for="error in errors"
                :key="error.error_id || error.error_name || error"
              >
                {{ error.error_name || error }}
              </div>
            </div>

            <ValidationProvider
              name="メールアドレス"
              rules="required|email|max:254"
              v-slot="providerProps"
              mode="aggressive"
            >
              <label for="preika-reset-email">メールアドレス</label>
              <CInput
                id="preika-reset-email"
                placeholder="name@example.com"
                autocomplete="username email"
                v-model="email"
                :is-valid="providerProps.errors.length ? false : null"
              >
                <template #prepend-content>
                  <CIcon name="cil-envelope-closed"/>
                </template>
              </CInput>
              <p v-if="providerProps.errors[0]" class="error">
                {{ providerProps.errors[0] }}
              </p>
            </ValidationProvider>

            <div class="preika-auth-form__actions">
              <router-link
                :to="{ name: 'Login' }"
                class="preika-auth-form__forgot"
              >
                ログイン画面へ戻る
              </router-link>

              <save-button
                label="再設定メールを送信"
                loading-label="送信中"
                :loading="loading"
                :disabled="!buttonFlg || observerProps.invalid || !observerProps.validated"
                @click="sendMail"
              />
            </div>
          </CForm>
        </ValidationObserver>
      </section>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import ConstList from './../../ConstList'
import SaveButton from '../../common/SaveButton'

export default {
  name: 'SendEmail',

  components: {
    SaveButton
  },

  data () {
    return {
      email: '',
      errors: [],
      buttonFlg: true,
      loading: false
    }
  },

  methods: {
    sendMail () {
      if (!this.buttonFlg || this.loading) return

      this.buttonFlg = false
      this.loading = true
      this.errors = []

      axios
        .post(process.env.VUE_APP_API_ORIGIN + '/send/mail', {
          email: this.email
        })
        .then(response => {
          if (response.data === ConstList.SUCCESS) {
            this.$router.push({
              name: 'ConfirmEmail',
              params: {
                email: this.email
              }
            })
            return
          }

          alert(ConstList.MAIL_ERROR)
          this.buttonFlg = true
        })
        .catch(error => {
          this.buttonFlg = true

          axios
            .post(
              process.env.VUE_APP_API_ORIGIN + '/error/frontError',
              { error: String(error) },
              {
                headers: {
                  'Content-Type': 'application/json'
                }
              }
            )
            .then(() => {
              alert(ConstList.SYSTEM_ERROR)
            })
            .catch(() => {
              alert(ConstList.SYSTEM_COMMUNICATION_ERROR)
            })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
